import axios from 'axios'
import {sessionHeader } from './main.api'
import Global from '../Global'

export default class LicenseApi {
    constructor(){}

    static List(channel_id = ''){
        /**Possible Errors **
         * No Errors         
         */
        let data = {}
        if(channel_id.length > 0){
            data = {
                "channel_id": channel_id
           }
        }        
        return axios
        .post(Global.GetAPIURL() + '/license/list', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })        
    }

    static Assign(channel_id = '', license_id = ''){
        /**Possible Errors **
         * license_not_found
         * license_already_assigned
         * user_has_no_access
         * user_has_no_access
         * unknown_license_type
         * channel_not_found
         */
        let data = {
                "channel_id": channel_id,
                "license_id": license_id
           }
        
        return axios
        .post(Global.GetAPIURL() + '/license/assign', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }

    static UnAssign(license_id = ''){
        /**Possible Errors **
         * user_has_no_access
         * unknown_license_type
         */
        let data = {
            "license_id": license_id
        }
        return axios
        .post(Global.GetAPIURL() + '/license/unassign', JSON.stringify(data), sessionHeader).catch(function(err) {
           if(typeof err.response != "undefined" && err.response.status == 401){
                Global.logout()
                sessionStorage.setItem("invalid_session_id", true)
            }
        })
    }
}
